var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Asset Summary")]),_c('summary-table',{attrs:{"summary":_vm.summary_data}}),_c('b-table',{attrs:{"table-info":"info","striped":"","hover":"","items":_vm.size_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }